// PWA utilities for Our Pickup

export const isPWA = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true;
};

export const isMobile = () => {
  return /Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent);
};

export const getPlatform = () => {
  const ua = window.navigator.userAgent;
  if (ua.includes('Android')) return 'android';
  if (ua.includes('iPhone') || ua.includes('iPad') || ua.includes('iPod')) return 'ios';
  if (ua.includes('Windows')) return 'windows';
  return 'other';
};

export const trackPWAInstall = async () => {
  try {
    const response = await fetch('/api/pwa/install', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        platform: getPlatform(),
        userAgent: window.navigator.userAgent,
        isPWA: isPWA(),
        timestamp: new Date().toISOString(),
        referrer: document.referrer || 'direct'
      })
    });
    return await response.json();
  } catch (error) {
    console.error('Error tracking PWA install:', error);
  }
};

// Track when user adds to home screen
export const listenForInstallPrompt = () => {
  let deferredPrompt = null;

  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('🔔 beforeinstallprompt fired');
    e.preventDefault();
    deferredPrompt = e;
    // Show install banner
    window.dispatchEvent(new CustomEvent('pwa-install-ready', { detail: { prompt: e } }));
  });

  window.addEventListener('appinstalled', () => {
    console.log('📱 App installed!');
    trackPWAInstall();
    // Show success message
    window.dispatchEvent(new CustomEvent('pwa-installed'));
  });
};

// Trigger install prompt
export const triggerInstallPrompt = async () => {
  const event = new CustomEvent('pwa-trigger-install');
  window.dispatchEvent(event);
  
  // The actual prompt will be handled by the component listening for this
};

// Get install status
export const getInstallStatus = () => {
  const isInstalled = localStorage.getItem('pwa_installed') === 'true';
  const installPrompted = localStorage.getItem('pwa_prompted') === 'true';
  return { isInstalled, installPrompted };
};
